import { render, staticRenderFns } from "./bigPackageManageDetail.vue?vue&type=template&id=1b1f6f10&scoped=true&"
import script from "./bigPackageManageDetail.vue?vue&type=script&lang=js&"
export * from "./bigPackageManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./bigPackageManageDetail.vue?vue&type=style&index=0&id=1b1f6f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1f6f10",
  null
  
)

export default component.exports